import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import type {
  NamedFloorAclGroups,
  NamedLocationAclGroups,
  NamedRoomAclGroups,
  NamedUserGroupAclGroups,
} from '../../types/acl-named.types';

@Component({
  selector: 'era-acl-group-list',
  templateUrl: './acl-group-list.component.html',
  styleUrls: ['./acl-group-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink],
})
export class AclGroupListComponent {
  readonly groups = input<
    NamedUserGroupAclGroups[] | NamedLocationAclGroups[] | NamedFloorAclGroups[] | NamedRoomAclGroups[]
  >();

  readonly header = input('Groups');
  readonly routePrefix = input('');
}
